import "../styles/Sidebar.css";

/**
 * Right-hand section nav. The page owns the selected key and renders the
 * matching content itself — see Rules.jsx, FAQ.jsx or HowTo.jsx.
 *
 * Each item is a real <button>. It was previously a click-only <li>, which is
 * not focusable, so a keyboard user could never leave the default section —
 * on the Rules page that meant five of six sections, including the whole
 * ticket-reporting procedure, were unreachable without a mouse. See issue #15.
 *
 * @param {string}   title     Heading above the menu.
 * @param {Array}    menu      [{ key, label, icon? }]
 * @param {string}   active    Currently selected key.
 * @param {Function} setActive Called with the clicked key.
 */
const SidebarRight = ({ title, menu = [], active, setActive }) => (
  <div className="sidebar-container">
    <div className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-title">
          <h3 className="sidebar-title">{title}</h3>
        </div>
      </div>
      <div className="sidebar-middle">
        <ul className="sidebar-menu">
          {menu.map((item) => {
            const isActive = active === item.key;
            return (
              <li key={item.key}>
                <button
                  type="button"
                  className={`sidebar-menu-item${isActive ? " active" : ""}`}
                  // Conveys selection to assistive tech; the red text alone
                  // carries the state visually and colour is not enough.
                  aria-current={isActive ? "true" : undefined}
                  // Guarded so a caller that forgets setActive renders an
                  // inert menu instead of blanking the app.
                  onClick={() => setActive?.(item.key)}
                >
                  {item.icon && <span className="sidebar-icon">{item.icon}</span>}
                  <span className="sidebar-label">{item.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  </div>
);

export default SidebarRight;
